/**
 * Convert "HH:MM" or "HH:MM:SS" (24-hour) into "h:mm AM/PM".
 * Returns the input unchanged if it doesn't look like a time string.
 */
export function formatTime12h(value: string | null | undefined): string {
  if (!value) return "";
  const parts = value.split(":");
  if (parts.length < 2) return value;
  const h24 = parseInt(parts[0], 10);
  const min = parts[1];
  if (Number.isNaN(h24) || min === undefined) return value;
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${min} ${period}`;
}

/** "9:00 AM – 5:00 PM" */
export function formatTimeRange12h(
  start: string | null | undefined,
  end: string | null | undefined,
): string {
  return `${formatTime12h(start)} – ${formatTime12h(end)}`;
}

/** Convert ISO timestamp to "h:mm AM/PM". */
export function formatIsoTime12h(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

/** Convert ISO timestamp to a localized date+time with AM/PM. */
export function formatIsoDateTime12h(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}
